
<template>
  <div>

    <v-row  class="justify-space-around align-bottom text-start mb-5 flex-wrap">
      

      <v-col cols="6" md="6" lg="6" class="pa-6 pb-0 pr-1">
        <v-card class="elevation-1 d-flex flex-column" height="100%">
          <v-card-title class="title text-start primary darken-2 white--text py-1"><span class="text-h6">Valor total dos pedidos</span>
            <v-spacer></v-spacer>
            <v-icon class="white--text">mdi-cash</v-icon>
          </v-card-title>
          <v-card-text class="mt-0 d-flex align-center flex-column flex-fill justify-center py-0 mt-0 ">
            <div class="text-xs-left py-2">
              <!-- <span>Valor total dos pedidos:</span> -->
              <span class="font-weight-bold ml-1 black--text text-h4 text-subtitle-1">
                {{ loading ? 'Carregando...' : Number(total_orders_sell_sum).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}
              </span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6" md="6" lg="6" class="pa-6 pb-0 pl-1" >
        <v-card class="elevation-1 d-flex flex-column" height="100%">
          <v-card-title class="title text-start primary darken-2 white--text py-1"><span class="text-h6">Numero total de pedidos:</span>
            <v-spacer></v-spacer>
            <v-icon class="white--text">mdi-counter</v-icon>
          </v-card-title>
          <v-card-text class="mt-0 d-flex align-center flex-column flex-fill justify-center py-0 mt-0 ">
            <div class="text-xs-left py-2">
              <!-- <span>Numero total de pedidos:</span> -->
              <span class="font-weight-bold ml-1 black--text text-subtitle-1">
                {{ loading ? 'Carregando...' : client_orders.length }}
              </span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" class="d-flex pb-0">
        
        <BtnCreateDataExport 
          class="pl-3"
          light-toolbar
          as-button
          api_model="Orders" 
          action="ClientOrderHistoric"
          :filters="filters"
          :hide_list="['pdf']"
          small
          :file_name="`Pedidos - ${client_name} - ${$moment(filters.start_date).format('DD-MM-YYYY')} a ${$moment().format('DD-MM-YYYY')}`"
        ></BtnCreateDataExport>
        <v-spacer></v-spacer>
        <v-btn @click="getOrders()" small class="ma-1 primary"><v-icon left >mdi-plus</v-icon> 6 meses</v-btn>
      </v-col>

      
    </v-row>

    <v-data-table 
      :loading="loading" 
      :headers="headers" 
      :items="client_orders" 
      mobile-breakpoint="1"
      class="mb-3 mt-n5"
    >
      <template v-slot:item.id="{item}">
        <div class="d-flex align-center">
          {{ item.id }}
          <v-btn small icon @click="goToOrder(item)">
            <v-icon small>mdi-open-in-new</v-icon>
          </v-btn>
        </div>
      </template>

      <template v-slot:item.attributes.solution="{item}">
        {{ item.attributes.solution }}
      </template>

      <template v-slot:item.attributes.finalized_at="{item}">
        {{ item.attributes.finalized_at ? $moment(item.attributes.finalized_at).format('DD/MM/YYYY') : '—' }}
      </template>

      <template v-slot:item.attributes.total_order_bags="{item}">
        {{ item.attributes.total_order_bags }}
      </template>

      <template v-slot:item.attributes.total_order_sell="{item}">
        <span> {{ new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.attributes.total_order_sell)  }} </span>
      </template>

      <template v-slot:item.attributes.all_payments="{item}">
        <div v-for="item in item.attributes.all_payments">
          ( <span> {{ new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.ammount)  }} </span> - {{ item.option }} - {{ item.times }} )
        </div>
      </template>

      <template v-slot:item.attributes.building.name="{item}">
        <span v-if="item.attributes?.building?.name">{{ item.attributes?.building?.name }}</span>
        <span v-else>---</span>
      </template>

      <template v-slot:item.attributes.vrt_transactions="{item}">
        <v-tooltip bottom v-for="(item, idx) in item.attributes.vrt_transactions" :key="idx">
          <template v-slot:activator="{ on, attrs }">
            <v-avatar size="30" :color="checkPaymentColor(item).color" class="mt-1 mr-1">
              <v-btn icon @click="openVrtPaymentsAssignedDialog(item)"><v-icon small class="white--text" v-bind="attrs" v-on="on">{{ payment_icon_map[item.payment_description].icon }}</v-icon></v-btn>
            </v-avatar>
          </template>
          {{ Number(item.ammount).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }} -
          {{ checkPaymentColor(item).hint_text }} - 
          {{ payment_icon_map[item.payment_description].name }} - 
          Valor pago: {{  Number(item.ammount_payed).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}
        </v-tooltip>
      </template>

    </v-data-table>


    <AssignedVrtPaymentDialog v-if="dialog" :selected_item="selected_item" @closeDialog="handleCloseDialog"></AssignedVrtPaymentDialog>
    
  </div>
</template>

<script>
import Api from '@/api/index';
import cimentao_links from "@/mixins/cimentao_links";
import { isOverdue } from '@/utils/dueDate'

export default {
  name: 'ClientProfileOrderHistory',
  mixins: [ cimentao_links ],
  components: {
    AssignedVrtPaymentDialog: () => import('./AssignedVrtPaymentDialog'),
    BtnCreateDataExport: () => import("@/components/data_export/BtnCreateDataExport.vue"),
  },
  props: {
    client_name: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      payment_icon_map:{
        "Dinheiro": {icon:"mdi-cash", name:"Dinheiro"},
        "Depósito": {icon:"mdi-email-open", name:"Depósito"},
        "Cheque": {icon:"mdi-checkbook", name:"Cheque"},
        "Boleto": {icon: "mdi-barcode", name:"Boleto"},
        "Transferência": {icon:"mdi-bank-transfer-out", name:"Transferência"},
        "PIX": {icon:"mdi-qrcode", name:"PIX"},
        "Permuta": {icon:"mdi-swap-horizontal", name:"Permuta"},
        "Nota promissória": {icon:"mdi-note", name:"Nota promissória"},
        null: {icon: 'mdi-receipt-text-outline', name: 'Fatura gerada sem método de pagamento'},
        '': {icon: 'mdi-receipt-text-outline', name: 'Fatura gerada sem método de pagamento'}
      },
      
      loading: false,
      client_orders: [],

      available: true,
      waiting_payment: true,
      done: false,

      dialog: false,
      selected_item: {},
      filters: {},

      headers: [
        { text: 'ID', value: "id"},
        { text: "Módulo", value: "attributes.solution" },
        { text: "Data de finalização", value: "attributes.finalized_at" },
        { text: "Obra", value: "attributes.building.name" },
        { text: "Quantidade", value: "attributes.total_order_bags", width:"100px" },
        { text: "Valor total de venda", value: "attributes.total_order_sell", sortable: false  },
        { text: "Forma de pagamento", value: "attributes.all_payments", sortable: false  },
        { text: "Faturas", value: "attributes.vrt_transactions", align: 'center'},
      ],

      default_range_date: 0,
    }
  },
  methods: {
    handleCloseDialog(){
      this.dialog = false
      this.selected_item = {}
    },
    openVrtPaymentsAssignedDialog(item){
      this.dialog = true
      this.selected_item = item
    },
    getOrders(reload) {
      this.loading = true
      if(!reload){
        this.default_range_date += 6
      }
      let params = this.mappedIndexParams()

      Api.ClientOrdersHistory.index({...params}).then(r=>{
        const retail_orders = r.data.retail.data || []
        const wholesale_orders = r.data.wholesale.data || []

        this.client_orders = [
          ...this.client_orders,
          ...retail_orders, 
          ...wholesale_orders,
        ]

      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    },
    checkPaymentColor(item){
      if (item.ammount == item.ammount_payed){
        return {color: 'green darken-2', hint_text: 'Fatura paga.'}
      }else if (isOverdue(item.DateExpired)){
        return {color: 'red darken-2', hint_text: `Vencimento: ${this.$moment(item.DateExpired).format('DD/MM/YYYY')}.` }
      }else{
        return {color: "yellow darken-2", hint_text: `Vencimento: ${this.$moment(item.DateExpired).format('DD/MM/YYYY')}.`}
      } 
    },
    goToOrder(item){
      if(item.attributes.vrt_transactions[0]?.solution == "wholesale"){
        this.goToWholesaleDoneOrder(item.id)
      }else{
        this.goToRetailPage(item.id)
      }
    },  
    mappedIndexParams(){
      let params = {
        client_id: this.$route.params.id,
        start_date: this.$moment().subtract(this.default_range_date, 'month').format('YYYY-MM-DD'),
        done_orders: true,
      }
      this.filters = {
        client_id: this.$route.params.id,
        start_date: params.start_date,
        done_orders: true,
      }

      return params
    },
  },
  computed: {
    total_orders_sell_sum(){
      if(!this.loading){
        return this.client_orders.reduce((acc, el) => acc + parseFloat(el.attributes.total_order_sell), 0)
      }else{
        return 0
      }
    },
  },
  mounted () {
    this.getOrders();
  },

}
</script>

<style scoped>

</style>